import React from 'react';
import { SOURCE_URL } from '../../../config';

interface SupportAppsLayoutProps {
    element: any
}

const SupportAppsLayout: React.FC<SupportAppsLayoutProps> = (element) => {


    return (
      <>
        <div className="container-fluid spacer-top apps-layout">
            <div className="row align-items-center">
                <div className="col-md-8 mb-md-0 mb-3">
                    <img src={SOURCE_URL + element?.element?.LargeImage?.data?.attributes?.url} className="img-fluid ml-auto mr-md-0 mr-auto d-block" alt="" />
                </div>
                <div className="col-md-3">
                    <div className="row">
                        <div className="col-md-12 col-sm-4 mb-3 text-center">
                            <a href={element?.element?.AppLink1} target="_blank" className="app-link">
                                <img src={SOURCE_URL + element?.element?.AppIcon1?.data?.attributes?.url} className="img-fluid" alt="" />
                            </a>
                        </div>
                        <div className="col-md-12 col-sm-4 mb-3 text-center">
                            <a href={element?.element?.AppLink2} target="_blank" className="app-link">
                                <img src={SOURCE_URL + element?.element?.AppIcon2?.data?.attributes?.url} className="img-fluid" alt="" />
                            </a>
                        </div>
                        <div className="col-md-12 col-sm-4 mb-3 text-center">
                            <a href={element?.element?.AppLink3} target="_blank" className="app-link">
                                <img src={SOURCE_URL + element?.element?.AppIcon3?.data?.attributes?.url} className="img-fluid" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </>
    );
};

export default SupportAppsLayout;